<template>
   <div>
  <div class="md:hidden p-6 btn-transparent min-h-screen flex justify-center items-center" style="background-color: #2D2E2C; ">
    <div class="w-full max-w-md">
      <flash-messages />
      <logo/>
      <form class="mt-6 bg-transparent rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-1">
          <text-input v-model="form.email" :error="form.errors.email" style="color: white;" class="font-bold mt-2" type="email" autofocus autocapitalize="off" placeholder="Email"/>
          <text-input v-model="form.password" :error="form.errors.password" class="font-bold mt-2"  type="password" placeholder="Contraseña" />
        <div class="flex justify-center items-center">
          <loading-button :loading="form.processing" class="btn-indigoOrange" type="submit"  style="color: #D35400; align-content: end;">ENTRAR</loading-button>
        </div>
        </div>
      </form>
    </div>
  </div>
  <div class="hidden md:flex p-6 btn-transparent min-h-screen flex justify-center items-center" style="background-color: #2D2E2C; ">
    <div class="w-full max-w-md">
      <logo/>
      <form class="mt-6 bg-transparent rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-1">
          <text-input v-model="form.email" :error="form.errors.email" style="color: white;" class="font-bold mt-2" type="email" autofocus autocapitalize="off" placeholder="Email"/>
          <text-input v-model="form.password" :error="form.errors.password" class="font-bold mt-2"  type="password" placeholder="Contraseña" />
          <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
          <div class="flex justify-center items-center">
          <br>
          <loading-button :loading="form.processing" class="px-8 py-3 btn-indigoOrange ml-auto" type="submit"  style="align-content: end;">Ingresar</loading-button>
          <br>   <br> <br>   <br>
        </div>
        </div>
      </form>
    </div>
  </div>
 </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInputlogin'
import LoadingButton from '@/Shared/LoadingButtonOrange'
import axios from "axios";
import FlashMessages from '@/Shared/FlashMessages'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
    FlashMessages,
  },
  data() {
    return {
      mensagge: '',
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
        codigo: '',
        token: '',
        
      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.route('login.store'))
    },
  },
}
</script>
